























































































import { Component, Prop, Mixins } from "vue-property-decorator";

// Types
import HasValidation from "@/mixins/HasValidation";
import { ValidationObserver } from "vee-validate";
import AdminBrandId from "@/mixins/adminBrandId";
import { ILeadForm } from "@/models/leads";
import { UUID } from "@/data/enums";

@Component({
  components: {
    "notifications-disabled-checkbox": () =>
      import("@/components/app/global/fields/notificationsDisabledCheckbox.vue")
  }
})
export default class LeadForm extends Mixins(HasValidation, AdminBrandId) {
  public declare $refs: {
    observer: InstanceType<typeof ValidationObserver>;
    name: HTMLFormElement;
  };

  @Prop({ required: true })
  public value!: ILeadForm;

  @Prop({ required: false, default: false })
  public isProcessing!: boolean;

  @Prop({ default: false })
  public isDisabled!: boolean;

  @Prop({ required: false, default: false })
  public exists!: boolean;

  @Prop({ required: false, default: true })
  public showButton!: boolean;

  public get form() {
    return this.value;
  }

  public set form(value) {
    this.$emit("input", value);
  }

  public created() {
    if (!this.exists) {
      this.form.brand_id =
        this.brandId !== UUID.ORG
          ? this.brandId
          : this.brands.length
          ? this.brands[0].id
          : UUID.ORG;
    }
  }

  public get brands() {
    return this.$_.filter(
      this.$_.get(this.$store, "state.auth.admin.brands", []),
      brand => brand.id
    );
  }

  public mounted() {
    this.$nextTick(() => {
      if (!this.$refs.name || this.exists) {
        return;
      }
      this.$refs.name.focus();
    });
  }

  public get formIsDisabled() {
    return this.isProcessing || this.hasErrors;
  }
}
